class EnterDataController {

    constructor(
        EnterDataService,
        FacilityEditFormService
    ){
        'ngInject';

        this.EnterDataService = EnterDataService;
        this.FacilityEditFormService = FacilityEditFormService;
    }

    $onInit() {
        this.formMetadata = null;
        this.savedFormData = null;
        this.lastUpdatedByEmail = null;
        this.merColumns = null;
        this.statToLabelDict = {};

        this.isFormVisible = false;
    }

    /***
     * Callback function for when all of the necessary filter parameters have been set in the FilterBar component.
     * Hides the edit form and triggers two asynchronous calls: one to fetch Stats data and one to fetch
     * Facility settings. Once both calls resolve, the form is displayed with the resulting data.
     *
     * @param clientId      the client whose form metadata should be returned.
     * @param countryId     the country of the facility whose form metadata should be returned.
     * @param campusId      the campus of the facility whose form metadata should be returned.
     * @param facilityId    the ID of the facility whose data will be updated.
     * @param month         the month of data that will be updated.
     * @param year          the year of the data that will be updated.
     */
    getForm(clientId, countryId, campusId, facilityId, month, year) {
        this.hideForm();

        this.getStatsForm(clientId, countryId, campusId, facilityId, month, year);
        this.getFacilitySettings(facilityId, month, year);
    }

    /***
     * Get both the form metadata and previously saved form data for the given
     * client/facility/month/year combination.
     *
     * @param clientId      the client whose form metadata should be returned.
     * @param countryId     the country of the facility whose form metadata should be returned.
     * @param campusId      the campus of the facility whose form metadata should be returned.
     * @param facilityId    the ID of the facility whose data will be updated.
     * @param month         the month of data that will be updated.
     * @param year          the year of the data that will be updated.
     */
    getStatsForm(clientId, countryId, campusId, facilityId, month, year) {
        this.EnterDataService.getForm(clientId, countryId, campusId, facilityId, month, year)
            .then((successResponse) => {
                this.areStatsSet = true;

                this.formMetadata  = successResponse.data.form_metadata;
                this.savedFormData = successResponse.data.saved_data || {};
                this.lastUpdatedByEmail = successResponse.data.last_updated_by_email;
                this.merColumns = successResponse.data.mer_columns;
                this.hasSavedData = successResponse.data.has_saved_data;
                this.isMerFacility = successResponse.data.is_mer_facility;
                Object.assign(this.savedFormData, {
                    client: clientId,
                    country: countryId,
                    campus: campusId,
                    facility: facilityId,
                    month: month,
                    year: year
                });
                this.populateStatToLabelDict();
                this.isFormVisible = true;

                if ('last_updated' in this.savedFormData) {
                    this.savedFormData.last_updated = new Date(this.savedFormData.last_updated);
                }

                this.isFormVisible = this.areStatsSet && this.areFacilitySettingsSet;
            });
    }

    /***
     * Fetch the latest Facility Settings for the given facility, mont, and year combination. These are the same
     * Facility Settings that are rendered in the ClientEdit.FacilityEditForm components.
     *
     * @param facilityId        the ID of the facility whose settings are being fetched.
     * @param month             the month of the settings being fetched (e.g. 1 for January, 3 for March, etc.)
     * @param year              the year of the settings being fetched.
     */
    getFacilitySettings(facilityId, month, year) {
        this.FacilityEditFormService.getFacilitySettings(facilityId, month, year)
            .then((successResponse) => {
                this.facilitySettings = successResponse;
                this.areFacilitySettingsSet = true;
                this.isFormVisible = this.areStatsSet && this.areFacilitySettingsSet;
            })
    }

    /***
     * Hides the form.
     */
    hideForm() {
        this.isFormVisible = false;
        this.areStatsSet = false;
        this.areFacilitySettingsSet = false;
    }

    /***
     * Populates a dictionary mapping a Stat name (e.g. "item_n_001") to its StatsLabel display
     * name (e.g. "Total New Activated Users").
     */
    populateStatToLabelDict() {
        this.statToLabelDict = {};
        for (const index in this.formMetadata) {
            const label = this.formMetadata[index];
            this.statToLabelDict[label.stats_column_name] = label.display_name;
        }
    }
}

export default EnterDataController;


// WEBPACK FOOTER //
// ./app/components/enter-data/enter-data-controller.js